export const EXTENSIONS_MAP = {
  'image/png': '.png',
  'image/jpeg': '.jpg',
  'image/gif': '.gif',
}

export const APPLICATION_PDF = 'application/pdf'
export const APPLICATION_WORD = 'application/msword'
export const APPLICATION_WORD_X = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
export const APPLICATION_POWERPOINT = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
export const APPLICATION_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export const IMAGE_JPEG = 'image/jpeg'
export const IMAGE_PNG = 'image/png'
export const IMAGE_GIF = 'image/gif'
export const IMAGE_WEBP = 'image/webp'
export const IMAGE_SVG = 'image/svg+xml'
export const IMAGE_BMP = 'image/bmp'

export const DOCS_EXTENSIONS_MAP = {
  [APPLICATION_PDF]: '.pdf',
  [APPLICATION_WORD_X]: '.docx',
  [APPLICATION_WORD]: '.doc',
  [APPLICATION_POWERPOINT]: '.pptx',
  [APPLICATION_XLSX]: '.xlsx',
  [IMAGE_JPEG]: '.jpeg',
  [IMAGE_PNG]: '.png',
  [IMAGE_GIF]: '.gif',
  [IMAGE_WEBP]: '.webp',
  [IMAGE_SVG]: '.svg',
  [IMAGE_BMP]: '.bmp'
};
